/**
 * GSTN's auto-calculated GSTR-3B figures beside ProGST's (D-10, FR-E35) — the words the 3B
 * screen says about them. The service compares and words every difference; this only says
 * when they were fetched, whether they were fetched for the JSON on file now, and prints a
 * figure that one side does not have as "no figure" rather than ₹0.00.
 */

import type { AutocalcFigure, Gstr3bAutocalc } from './api'
import { istWords } from './filingLane'

/** The line under the heading: the service's sentence, when, and whether it still applies. */
export function autocalcLines(a: Gstr3bAutocalc): string[] {
  if (!a.fetched) return [a.words]
  const lines = [a.words]
  const when = istWords(a.at)
  if (when) lines.push(`Fetched at ${when}.`)
  if (!a.current) {
    lines.push(
      'These were fetched for an earlier GSTR-3B JSON — fetch them again for the JSON on file before the set-off.',
    )
  }
  return lines
}

/** A figure in rupees, or "no figure" when that side has none. Never 0.00 for a blank. */
export function figureWords(paise: number | null): string {
  if (paise === null) return 'no figure'
  return (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/** The figures that differ, in the form's order (the service's order). */
export function differing(a: Gstr3bAutocalc): AutocalcFigure[] {
  return a.figures.filter((f) => f.sentence !== null)
}

/** The fetch is offered on a client-approved 3B, to someone who may update the period. */
export function canFetch(state: string | undefined, mayUpdate: boolean): boolean {
  return mayUpdate && state === 'client_approved'
}
